// extracted by mini-css-extract-plugin
module.exports = {"itemList":"ItemList_itemList__2ojaX"};